import { defineMessages } from "react-intl";
import hooks from "../../node_modules/moment/dist/moment.js";
import { of } from "rxjs";
import { filter } from "rxjs/operators";
import { isActionOf } from "typesafe-actions";
import { ReferrerType, RevenueShareOfferingStatus } from "../../contract/pam.js";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import { mergeMap, map } from "../../otel/rxjs.js";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import { BaseEpicsBuilder } from "../../redux-folder/epicsBuilder.js";
import "../../redux-folder/actions.js";
import "../../api/types.js";
import "immer";
import { momentToTimestampSeconds } from "../../utils/date.js";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "rxjs/ajax";
import "fast-deep-equal/es6";
import "redux";
import { getEntityActions } from "../../redux-folder/entity/actions.js";
import "../../redux-folder/entity/epics.js";
import "normalizr";
import "../../redux-folder/entity/EntityProvider.js";
import { messageActions } from "../../redux-folder/message/actions.js";
import { getRealtimeActions } from "../../redux-folder/realtime/actions.js";
import "reselect";
import "react-redux";
import "react-router";
import { RealtimeMessageTrigger } from "../../redux-folder/realtime/types.js";
import "../../redux-folder/realtime/RealtimeNotification.js";
import { playerReferralActions } from "./actions.js";
import { UpdateAffiliateBtagModelTypeName } from "./constants.js";
import { UserReferralFormModel } from "./service.js";
const localized = defineMessages({
  addReferrerInfoSuccess: {
    id: "PlayerReferrerInfoEpicsBuilder_addReferrerInfoSuccess",
    defaultMessage: "Referrer info is successfully added"
  },
  addReferrerInfoFailed: {
    id: "PlayerReferrerInfoEpicsBuilder_addReferrerInfoFailed",
    defaultMessage: "Failed to add referrer info"
  },
  updateReferrerInfoSuccess: {
    id: "PlayerReferrerInfoEpicsBuilder_updateReferrerInfoSuccess",
    defaultMessage: "Referrer info is successfully updated"
  },
  updateReferrerInfoFailed: {
    id: "PlayerReferrerInfoEpicsBuilder_updateReferrerInfoFailed",
    defaultMessage: "Failed to update referrer info"
  },
  removeReferrerInfoSuccess: {
    id: "PlayerReferrerInfoEpicsBuilder_removeReferrerInfoSuccess",
    defaultMessage: "Referrer info is successfully removed"
  },
  removeReferrerInfoFailed: {
    id: "PlayerReferrerInfoEpicsBuilder_removeReferrerInfoFailed",
    defaultMessage: "Failed to remove referrer info"
  },
  editExpirationDateSuccess: {
    id: "PlayerReferrerInfoEpicsBuilder_editExpirationDateSuccess",
    defaultMessage: "Expiration date is successfully updated"
  },
  editExpirationDateFailed: {
    id: "PlayerReferrerInfoEpicsBuilder_editExpirationDateFailed",
    defaultMessage: "Failed to update expiration date"
  },
  editRevenueShareSuccess: {
    id: "PlayerReferrerInfoEpicsBuilder_editRevenueShareSuccess",
    defaultMessage: "Revenue share is successfully updated"
  },
  editRevenueShareFailed: {
    id: "PlayerReferrerInfoEpicsBuilder_editRevenueShareFailed",
    defaultMessage: "Failed to update revenue share"
  }
});
class PlayerReferralEpicsBuilder extends BaseEpicsBuilder {
  _referralsService;
  _userService;
  _mapper;
  _entityActions;
  _realtimeActions;
  constructor(mapper, referralsService, userService) {
    super();
    this._referralsService = referralsService;
    this._userService = userService;
    this._mapper = mapper;
    this._entityActions = getEntityActions();
    this._realtimeActions = getRealtimeActions();
  }
  buildEpicList() {
    return [
      this.buildChangeReferrerInfoEpic(),
      this.buildAddReferrerInfoRequestEpic(),
      this.buildAddReferrerInfoSuccessEpic(),
      this.buildAddReferrerInfoFailureEpic(),
      this.buildUpdateReferrerInfoRequestEpic(),
      this.buildUpdateReferrerInfoSuccessEpic(),
      this.buildUpdateReferrerInfoFailureEpic(),
      this.buildRemoveReferrerInfoRequestEpic(),
      this.buildRemoveReferrerInfoSuccessEpic(),
      this.buildRemoveReferrerInfoFailureEpic(),
      this.buildEditExpirationDateRequestEpic(),
      this.buildEditExpirationDateSuccessEpic(),
      this.buildEditExpirationDateFailureEpic(),
      this.buildEditRevenueShareRequestEpic(),
      this.buildEditRevenueShareSuccessEpic(),
      this.buildEditRevenueShareFailureEpic()
    ];
  }
  buildChangeReferrerInfoEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(playerReferralActions.changeReferrerInfo.request)),
      mergeMap((action) => {
        const requestActionMapping = {
          ["add"]: playerReferralActions.addReferrerInfo,
          ["update"]: playerReferralActions.updateReferrerInfo,
          ["remove"]: playerReferralActions.removeReferrerInfo
        };
        return of(requestActionMapping[action.payload?.mode].request(action.payload?.referral));
      })
    );
  }
  buildAddReferrerInfoRequestEpic() {
    return this.buildRequestEpic(
      playerReferralActions.addReferrerInfo,
      (payload) => payload?.referrer_type === ReferrerType.P2P ? this._referralsService.addReferrerInfo(payload) : this._userService.updateAffiliateBtag(
        this._mapper.map(payload, UserReferralFormModel, UpdateAffiliateBtagModelTypeName)
      )
    );
  }
  buildAddReferrerInfoSuccessEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(playerReferralActions.addReferrerInfo.success)),
      mergeMap(
        () => of(
          messageActions.saveMessage({ message: localized.addReferrerInfoSuccess, mode: "success" }),
          playerReferralActions.changeReferrerInfo.success()
        )
      )
    );
  }
  buildAddReferrerInfoFailureEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(playerReferralActions.addReferrerInfo.failure)),
      mergeMap(
        () => of(
          messageActions.saveMessage({ message: localized.addReferrerInfoFailed, mode: "error" }),
          playerReferralActions.changeReferrerInfo.failure()
        )
      )
    );
  }
  buildUpdateReferrerInfoRequestEpic() {
    return this.buildRequestEpic(
      playerReferralActions.updateReferrerInfo,
      (payload) => payload?.referrer_type === ReferrerType.P2P ? this._referralsService.updateReferrerInfo(payload) : this._userService.updateAffiliateBtag(
        this._mapper.map(payload, UserReferralFormModel, UpdateAffiliateBtagModelTypeName)
      )
    );
  }
  buildUpdateReferrerInfoSuccessEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(playerReferralActions.updateReferrerInfo.success)),
      mergeMap(({ payload }) => {
        const affiliateRequestPayload = payload?.requestPayload;
        const btag = affiliateRequestPayload?.affiliate?.btag;
        const updateStateActions = btag ? [
          this._entityActions.updateItem({
            type: "UserProfile",
            id: affiliateRequestPayload?.uid,
            updatedItem: { affiliate: { btag } }
          }),
          this._entityActions.clean({
            type: "PlayerReferral",
            ids: [affiliateRequestPayload.id]
          })
        ] : [];
        return of(
          ...updateStateActions,
          messageActions.saveMessage({ message: localized.updateReferrerInfoSuccess, mode: "success" }),
          playerReferralActions.changeReferrerInfo.success()
        );
      })
    );
  }
  buildUpdateReferrerInfoFailureEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(playerReferralActions.updateReferrerInfo.failure)),
      mergeMap(
        () => of(
          messageActions.saveMessage({ message: localized.updateReferrerInfoFailed, mode: "error" }),
          playerReferralActions.changeReferrerInfo.failure()
        )
      )
    );
  }
  buildRemoveReferrerInfoRequestEpic() {
    return this.buildRequestEpic(
      playerReferralActions.removeReferrerInfo,
      (payload) => this._referralsService.removeReferrerInfo(payload)
    );
  }
  buildRemoveReferrerInfoSuccessEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(playerReferralActions.removeReferrerInfo.success)),
      mergeMap(
        () => of(
          // event to update client state
          this._realtimeActions.event({
            entity: "PlayerReferral",
            items: [],
            trigger: { type: RealtimeMessageTrigger.Delete }
          }),
          messageActions.saveMessage({ message: localized.removeReferrerInfoSuccess, mode: "success" }),
          playerReferralActions.changeReferrerInfo.success()
        )
      )
    );
  }
  buildRemoveReferrerInfoFailureEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(playerReferralActions.removeReferrerInfo.failure)),
      mergeMap(
        () => of(
          messageActions.saveMessage({ message: localized.removeReferrerInfoFailed, mode: "error" }),
          playerReferralActions.changeReferrerInfo.failure()
        )
      )
    );
  }
  buildEditExpirationDateRequestEpic() {
    return this.buildRequestEpic(
      playerReferralActions.editExpirationDate,
      (payload) => this._referralsService.editExpirationDate(payload)
    );
  }
  buildEditExpirationDateSuccessEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(playerReferralActions.editExpirationDate.success)),
      mergeMap((res) => {
        const { referrer_id, referee, expiration_date } = res.payload.responsePayload;
        const updatedItem = {
          expiration_date: {
            seconds: expiration_date.seconds
          },
          revenue_share_offering_status: expiration_date.seconds > momentToTimestampSeconds(hooks()) ? RevenueShareOfferingStatus.Active : RevenueShareOfferingStatus.Inactive
        };
        return of(
          messageActions.saveMessage({ message: localized.editExpirationDateSuccess, mode: "success" }),
          this._entityActions.updateItem({
            type: "PlayerReferral",
            id: `${referrer_id}-${referee?.uid}`,
            updatedItem
          })
        );
      })
    );
  }
  buildEditExpirationDateFailureEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(playerReferralActions.editExpirationDate.failure)),
      map(() => messageActions.saveMessage({ message: localized.editExpirationDateFailed, mode: "error" }))
    );
  }
  buildEditRevenueShareRequestEpic() {
    return this.buildRequestEpic(
      playerReferralActions.editRevenueShare,
      (payload) => this._referralsService.editRevenueShare(payload)
    );
  }
  buildEditRevenueShareSuccessEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(playerReferralActions.editRevenueShare.success)),
      mergeMap((res) => {
        const { referrer_id, referee, revenue_share } = res.payload.responsePayload;
        const updatedItem = { revenue_share };
        return of(
          messageActions.saveMessage({ message: localized.editRevenueShareSuccess, mode: "success" }),
          this._entityActions.updateItem({
            type: "PlayerReferral",
            id: `${referrer_id}-${referee?.uid}`,
            updatedItem
          })
        );
      })
    );
  }
  buildEditRevenueShareFailureEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(playerReferralActions.editRevenueShare.failure)),
      map(() => messageActions.saveMessage({ message: localized.editRevenueShareFailed, mode: "error" }))
    );
  }
}
export {
  PlayerReferralEpicsBuilder,
  localized
};
//# sourceMappingURL=epics.js.map
